class RadialBackgroundAnimation{

	constructor(){

		this.randomX = this.random(-400, 400);
		this.randomY = this.random(-200, 200);
		this.randomDelay = this.random(0, 50);
		this.randomTime = this.random(6, 12);
		this.randomTime2 = this.random(5, 6);
		this.randomAngle = this.random(-30, 150);

		let radials = document.querySelectorAll('.section-texture-radial-animation');
		radials.forEach( (radial) => {
			let blurs = radial.querySelectorAll('.blur');
			blurs = gsap.utils.toArray(blurs);

			blurs.forEach((blur) => {
				gsap.set(blur, {
					x: this.randomX(-1),
					y: this.randomX(1),
					rotation: this.randomAngle(-1)
				});

				this.moveX(blur, 1);
				this.moveY(blur, -1);
				this.rotate(blur, 1);
			});
		});

	}

	random(min, max) {
		const delta = max - min;
		return (direction = 1) => (min + delta * Math.random()) * direction;
	}

	rotate(target, direction) {
		gsap.to(target, this.randomTime2(), {
			rotation: this.randomAngle(direction),
			// delay: randomDelay(),
			ease: Sine.easeInOut,
			onComplete: () => {
				this.rotate(target, 1);
			},
			onCompleteParams: [target, direction * -1]
		});
	}

	moveX(target, direction) {
		gsap.to(target, this.randomTime(), {
			x: this.randomX(direction),
			ease: Sine.easeInOut,
			onComplete: () => {
				this.moveX(target, 1);
			},
			onCompleteParams: [target, direction * -1]
		});
	}

	moveY(target, direction) {
		gsap.to(target, this.randomTime(), {
			y: this.randomY(direction),
			ease: Sine.easeInOut,
			onComplete: () => {
				this.moveY(target, -1);
			},
			onCompleteParams: [target, direction * -1]
		});
	}

}